import { render, staticRenderFns } from "./group-card.vue?vue&type=template&id=768b2b20&scoped=true&"
import script from "./group-card.vue?vue&type=script&lang=js&"
export * from "./group-card.vue?vue&type=script&lang=js&"
import style0 from "./group-card.vue?vue&type=style&index=0&id=768b2b20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768b2b20",
  null
  
)

export default component.exports